export default __webpack_public_path__ + "static/main-29.408.0-1316854eb3135b2b0a5b424aad0aa0a2.css";